<template>
  <div>
    <proTreeCom ref="proTreeCom" :curData="curData" v-myTitle :data-title="title"/>
  </div>
</template>
<script>
import proTreeCom from '../securityCenter/client/proTree.vue'
import { Base64 } from 'js-base64'

export default {
  components: {
    proTreeCom
  },
  data () {
    return {
      curData: '',
      title: '进程树'
    }
  },
  mounted () {
    let object = eval('(' + this.$route.query.curData + ')')
    this.curData = object
    this.$refs.proTreeCom.visible = true
    this.title = `【${this.curData.pcName}】-${this.curData.barName}[${this.curData.barId}]进程树`
    document.title = this.title
    // this.initCNZZ();
  },
  watch: {
    '$route' () {
      if (window._czc) {
        // 监听路由变化
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = '/';
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  },
  methods: {
    initCNZZ() {
      // 添加脚本
      const script = document.createElement('script');
      script.src = 'https://s9.cnzz.com/z_stat.php?id=1281282837&web_id=1281282837';
      script.language = 'JavaScript';
      script.id = 'cnzz';
      document.body.appendChild(script);
    }
  }
}
</script>